import { CardContent, Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useHistory } from 'react-router';

import DataLabel from '../../ui/card/DataLabel';

import { PathBuilder } from 'src/routing';

interface AlarmElementProps {
  alarmId: string;
  alarmTagId: string;
  errorCode?: string;
  siteId: number;
  status: string;
  title: string;
  triggered: string;
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: 16,
  },
  container: {
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
}));

const AlarmElement = ({
  alarmId,
  alarmTagId,
  errorCode,
  siteId,
  status,
  title,
  triggered,
}: AlarmElementProps) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <CardContent>
      <Grid container className={classes.container}>
        <Grid item xs={10}>
          <Typography className={classes.title}>{title}</Typography>
        </Grid>
        <Grid item>
          <IconButton
            data-testid="alarm-details-button"
            onClick={() => history.push(PathBuilder.ALARM_DETAILS(siteId, alarmId, alarmTagId))}
          >
            <ArrowForwardIcon />
          </IconButton>
        </Grid>
      </Grid>
      {errorCode && <DataLabel label="Error Code" value={errorCode} divider />}
      <DataLabel label="Status" value={status} />
      <DataLabel label="Triggered" value={triggered} />
    </CardContent>
  );
};

export default AlarmElement;
